<!-- <vc4a-flash type="success" message="Your action was successful"/> -->

<template>
    <div class="flash" :class="getType" >{{ message }}</div>
</template>

<script>
export default {
    name: "Vc4aFlash",
    props: {
        message: String,
        type: String
    },
    computed: {
        getType() {
            switch (this.type) {
                case 'danger':
                    return 'flash--danger';
                case 'success':
                    return 'flash--success';
                case 'warning':
                    return 'flash--warning';
                default:
                    return 'flash--info';
            }
        }
    }
}
</script>